import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

const USERWAY_SCRIPT_SRC = 'https://cdn.userway.org/widget.js';

export const useUserWay = (): void => {
	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			return;
		}

		const account = process.env.REACT_APP_USERWAY_ACCOUNT;

		if (!account) {
			return;
		}

		const existingScript = document.querySelector<HTMLScriptElement>('script[data-userway="true"]');

		if (existingScript) {
			return;
		}

		const script = document.createElement('script');

		script.src = USERWAY_SCRIPT_SRC;
		script.async = true;
		script.setAttribute('data-account', account);
		script.setAttribute('data-userway', 'true');

		document.head.appendChild(script);

		return () => {
			script.remove();
		};
	}, []);
};
